import { assert } from '../../../lib/assert-sidecar'
import { l } from '../../../lib/imports'
import { voyageBodies } from '../voyageBodies-sidecar'
import { EVoyageCrewType } from '../voyageCrew'
import { voyageCrew } from '../voyageCrew-sidecar'
import { voyageParticles } from '../voyageParticles-sidecar'
import { voyageToolBodyAlign } from '../voyageToolBodyAlign-sidecar'
import { voyageWebsockets } from '../voyageWebsockets-sidecar'
import { voyageMessageCrewStyle } from './voyageMessageCrewStyle-sidecar'
import { EVoyageMessage } from './voyageMessageIds'

import type { IMessageWriter } from '../../../engine/messageWriter'
import { messageWriter } from '../../../engine/messageWriter-sidecar'
import { websockets } from '../../../engine/websockets-sidecar'
import { voyageSounds } from '../voyageSounds-sidecar'

export interface IMessageCrewCreate {
  crewId: number
  type: number
  team: number
  i: number
  j: number
  method: EVoyageCrewCreateMethod
  energy: number
  name?: string
}

export enum EVoyageCrewCreateMethod {
  Normal = 0,
  Teleport = 1,
}

export const voyageMessageId = EVoyageMessage.CrewCreate

export function write(m: IMessageWriter, d: IMessageCrewCreate) {
  messageWriter.write8(m, voyageMessageId)
  messageWriter.write32(m, d.crewId)
  messageWriter.write16(m, d.type)
  messageWriter.write16(m, d.team)
  messageWriter.write16(m, d.i)
  messageWriter.write16(m, d.j)
  messageWriter.write8(m, d.method)
  messageWriter.write16(m, d.energy)
  messageWriter.writeString(m, d.name || '')
}

export function read(m: IMessageWriter) {
  let t = messageWriter.read8(m)
  assert.eq(t, voyageMessageId)

  let d: IMessageCrewCreate = {
    crewId: messageWriter.read32(m),
    type: messageWriter.read16(m),
    team: messageWriter.read16(m),
    i: messageWriter.read16(m),
    j: messageWriter.read16(m),
    method: messageWriter.read8(m),
    energy: messageWriter.read16(m),
    name: messageWriter.readString(m),
  }

  return d
}

export function test() {
  let ex: IMessageCrewCreate = {
    crewId: 100,
    type: 5,
    team: 1,
    i: 7,
    j: 8,
    method: EVoyageCrewCreateMethod.Teleport,
    energy: 333,
    name: 'test',
  }
  messageWriter.test('crew-create', ex, write, read)
}

export function process(m: IMessageWriter) {
  let msg = read(m)
  let cr = voyageCrew.findByIdSafe(msg.crewId)
  assert.nil(cr, 'oh no crew already exists')

  cr = voyageCrew.create(msg.type, msg.team)
  cr.id = msg.crewId
  cr.energy = msg.energy
  if (msg.name) {
    cr.name = msg.name
  }
  voyageCrew.moveToIJ(cr, msg)

  if (voyageWebsockets.getIsHost()) {
    if (cr.type === EVoyageCrewType.Crew) {
      if (cr.crewState && cr.crewState.body) {
        // Set our body too
        let b = cr.crewState.body
        voyageMessageCrewStyle.sendMessageAndImmediatelyExecute({
          crewId: cr.id,
          body: b.body.idx,
          hair: b.hair.idx,
          head: b.head.idx,
          bodyColor: b.bodyColor,
          hairColor: b.hairColor,
          headColor: b.headColor,
        })
      }
    }
    // if (cr.type === EVoyageCrewType.Alien) {
    //   let alien = voyageCrew.create(EVoyageCrewType.Alien, 1)
    //   voyageCrew.moveToIJ(alien, msg)
    // }
  }

  if (msg.method === EVoyageCrewCreateMethod.Teleport) {
    voyageSounds.playTeleport()
    voyageParticles.createMultiple('teleport', cr.x, cr.y + 16, 18)
  }

  // let alien = voyageCrew.create(EVoyageCrewType.Alien, 1)
  // voyageCrew.moveToIJ(alien, fl)
  // voyageSounds.playTeleport()
  //
}

export function sendMessageAndImmediatelyExecute(msg: IMessageCrewCreate) {
  websockets._sendMessageAndImmediatelyExecute(write, msg)
}
